<template>
  <div class="item">
    <i
      class="user clock middle aligned icon"
      v-bind:class="{ green: !is_closable }"
    ></i>
    <div class="content">
      {{ phase.name }}
      <div
        class="ui right floated basic mini icon button"
        v-show="is_closable"
        @click="close_phase(phase, section)"
      >
        <i class="green check icon"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast, success_toast } from "@/utils";

export default {
  name: "",
  props: { phase: Object, section: Object },
  computed: {
    is_closable() {
      let vm = this;
      let trgt = vm.section.crs_phase_records.find(
        (r) => r.phase_uuid == vm.phase.uuid,
      );
      if (trgt) return false;
      else return true;
    },
  },
  methods: {
    close_phase(phase, section) {
      let vm = this;
      this.$alertify.confirm(
        this.$t("are you sure to confirm phase?"),
        function() {
          local_api(vm, "post", "/course/record/do-confirm-phase", {
            u: phase.uuid,
            s: section.uuid,
          })
            .then(() => {
              success_toast(vm.$t("phase confirmed"));
              vm.$emit("phase_confirmed");
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
  },
};
</script>
